import React, { useState,useRef,useEffect } from "react";
import {  Grid, List, ListItem, ListItemText, Box } from "@material-ui/core";
import { ExpandMore } from '@material-ui/icons';
import SearchBar from "components/searchBar";
import { toast } from "react-toastify";
import { useStyles } from "./style";

export default function UserPermissions({ allUsers,changeHandler, selectedUsers=[] }) {
    const classes = useStyles();
    const ref = useRef(null);
    const [rightSideUsers,setRightSideUsers]=useState(selectedUsers);
    const [leftSearchText,setLeftSearchText]=useState('');
    const [rightSearchText,setRightSearchText]=useState('');

    
    const [selectedState,setSelectedState]=useState([]);
    const toggleSelection = (e, Id) => {
        e.stopPropagation();
        if (selectedState.includes(Id)) {
            const newData = selectedState.filter(sid => sid !== Id);
            setSelectedState(newData)
        } else {
            const newData = [...selectedState];
            newData.push(Id)
            setSelectedState(newData)
        }
    }

    useEffect(()=>{
        setRightSideUsers(selectedUsers)
    },[selectedUsers])

    useEffect(() => {
        if (ref && ref?.current) { 
            changeHandler('users',rightSideUsers);//invoke the parent
        } else {
            ref.current = true;
        }
        // eslint-disable-next-line
    }, [rightSideUsers])


    const handleSearch = e => {
        const searchText = e.target.value.toLowerCase();
        if (e.target.name === 'rightSearchBox') {
            setRightSearchText(searchText)
        } else if (e.target.name === 'leftSearchBox') {
            setLeftSearchText(searchText)
        }
    }

    const getFilteredRecords = (data, searchText) => {
        return data.filter(user =>  user.full_name.toLowerCase().includes(searchText))
    }

  
    const moveItems = direction => {
        if (selectedState.length === 0) {
            toast.error("No User Selected to Move!");
        }else{
            if (direction === 'right') {
                const newSetUsers=Array.from(new Set([...rightSideUsers,...selectedState]));
                setRightSideUsers(newSetUsers);
            } else {
                const afterMovetoLeft=[...rightSideUsers].filter(id=>!selectedState.includes(id));
                setRightSideUsers(afterMovetoLeft);
               
            }
        }
        
    }
  
    const leftUsers = getFilteredRecords(allUsers.filter(item => !rightSideUsers.includes(item.id)), leftSearchText);
    const rightUsers = getFilteredRecords(allUsers.filter(item => rightSideUsers.includes(item.id)), rightSearchText);

    return (
        <React.Fragment>
            <Box display='flex'>
              
            <Grid item xs={6}>
                    <Box className={classes.header} >All Users</Box>
                    <Box className={classes.searchContainer}>
                        <SearchBar name="leftSearchBox" changeHandler={handleSearch} />
                    </Box>

                    <Box className={classes.listContainer}>
                        <List
                            sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                            component="div"
                        > 
                            {leftUsers && leftUsers?.map((item, uIndex) => (
                                <ListItem selected={selectedState.includes(item.id)}  key={'lKey-' + uIndex} onClick={e => toggleSelection(e, item.id)} button >
                                    <ListItemText primary={item.full_name} secondary={item.email} />
                                </ListItem>
                            ))
                            }

                        </List>
                    </Box>
                </Grid>
                <Grid className={classes.arrowContainer}>
                    <Box className={classes.leftRightArrow}>
                        <ExpandMore onClick={e => moveItems('right')} className={classes.moveToRight} />
                        <ExpandMore onClick={e => moveItems('left')} className={classes.moveToLeft} />
                    </Box>

                </Grid>

                <Grid item xs={5}>
                    <Box className={classes.header} >Selected Users</Box>
                    <Box className={classes.searchContainer}>
                        <SearchBar name="rightSearchBox" changeHandler={handleSearch} />
                    </Box>
                    <Box className={classes.listContainer}>
                        <List
                            sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                            component="div"
                        > 
                            {rightUsers && rightUsers?.map((item, uIndex) => (
                                <ListItem selected={selectedState.includes(item.id)}  key={'rKey-' + uIndex} onClick={e => toggleSelection(e, item.id)} button >
                                    <ListItemText primary={item.full_name} secondary={item.email} />
                                </ListItem>
                            ))
                            }

                        </List>
                    </Box>
                     
                </Grid>
            </Box>
        </React.Fragment>
    )
}